<div class="rounded-corners mat-elevation-z8" style="height: 100%;">
    <table mat-table class="no-borders status-eventlog-list" [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="occurenceTimestamp">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span translate="Table.RequestLog"></span>
            </th>
            <td mat-cell *matCellDef="let row">
                <div class="badge-column float-start"><app-badge-status-display
                        [badgeStatus]="convertEventStatusToBadgeStatus(row.eventType)"></app-badge-status-display></div>
                <div class="d-flex">{{row.occurenceTimestamp | date:'dd-MM-yy HH:mm'}} -
                    {{convertEventToTranslatedContent(row)}}</div>
            </td>

            <!-- Hidden column for email activity-->
        <!-- </ng-container><ng-container matColumnDef="sourceDisplayName">
            <th mat-header-cell *matHeaderCellDef>
                <span  *ngIf="hasAnyEmailActivity">
                        <button type="button" (click)="$event.stopPropagation();" (click)="toggleShowEmail()"
                            class="btn btn-sm" aria-expanded="false">
                            <ng-container *ngIf="showEmailActivity"><i class="bi bi-envelope-heart bi-large" ></i></ng-container>
                            <ng-container *ngIf="!showEmailActivity"><i class="bi bi-envelope-slash-fill bi-large"></i></ng-container>
                            
                        </button></span>
            </th>
            <td mat-cell *matCellDef="let row">
            </td> -->

        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row class="small-row" *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>